import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import CircularProgress from "@mui/material/CircularProgress";
import Divider from "@mui/material/Divider";
import { Receipt } from "@phosphor-icons/react/Receipt";
import { FC } from "react";

import {
	InvoicesPagination,
	InvoicesPaginationProps,
} from "./invoices-pagination";
import { InvoicesTable, InvoicesTableProps } from "./invoices-table";

export interface InvoiceHistoryProps {
	isLoading: boolean;
	tableProps: InvoicesTableProps;
	paginationProps: InvoicesPaginationProps;
}

export const InvoiceHistory: FC<InvoiceHistoryProps> = ({
	isLoading,
	tableProps,
	paginationProps,
}) => {
	return (
		<Card>
			<CardHeader
				avatar={
					<Avatar>
						<Receipt fontSize="var(--Icon-fontSize)" />
					</Avatar>
				}
				title="Invoice history"
			/>
			<CardContent>
				{isLoading ? (
					<CircularProgress />
				) : (
					<Card>
						<Box sx={{ overflowX: "auto" }}>
							<InvoicesTable {...tableProps} />
						</Box>
						<Divider />
						<InvoicesPagination {...paginationProps} />
					</Card>
				)}
			</CardContent>
		</Card>
	);
};
